import { DbLine, DbMesh } from "@/CadEngine";
import * as THREE from "three";
export abstract class FMathUtils {
  // 求两条线段的交点
  static GetLineSegmentIntersection(line1: DbLine, line2: DbLine) {
    let x1 = line1.points[0],
      y1 = line1.points[1],
      x2 = line1.points[3],
      y2 = line1.points[4];
    let x3 = line2.points[0],
      y3 = line2.points[1],
      x4 = line2.points[3],
      y4 = line2.points[4];
    let ua, ub, denom, x, y;
    denom = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);
    if (denom == 0) {
      return null; // 两条线段平行
    }
    ua = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / denom;
    ub = ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) / denom;
    if (ua < 0 || ua > 1 || ub < 0 || ub > 1) {
      return null; // 两条线段没有交点
    }
    x = x1 + ua * (x2 - x1);
    y = y1 + ua * (y2 - y1);
    return new THREE.Vector3(x, y, 0);
  }

  // 求两条直线的交点
  static GetLineIntersection(line1: DbLine, line2: DbLine) {
    let denominator,
      a,
      b,
      numerator1,
      numerator2,
      result: THREE.Vector3 = new THREE.Vector3();
    let line1StartX = line1.points[0];
    let line1StartY = line1.points[1];
    let line1EndX = line1.points[line1.points.length - 3];
    let line1EndY = line1.points[line1.points.length - 2];
    let line2StartX = line2.points[0];
    let line2StartY = line2.points[1];
    let line2EndX = line2.points[line2.points.length-3];
    let line2EndY = line2.points[line2.points.length-2];

    denominator =
      (line2EndY - line2StartY) * (line1EndX - line1StartX) -
      (line2EndX - line2StartX) * (line1EndY - line1StartY);

    // 如果为0则平行
    if (denominator == 0) {
      return null;
    }

    a = line1StartY - line2StartY;
    b = line1StartX - line2StartX;
    numerator1 = (line2EndX - line2StartX) * a - (line2EndY - line2StartY) * b;
    numerator2 = (line1EndX - line1StartX) * a - (line1EndY - line1StartY) * b;
    a = numerator1 / denominator;
    b = numerator2 / denominator;

    result.x = line1StartX + a * (line1EndX - line1StartX);
    result.y = line1StartY + a * (line1EndY - line1StartY);

    return result;
  }

  // 检测线段是否和mesh相交
  static CheckLineIntersectMesh(
    lines: DbLine[],
    meshs: THREE.Mesh[],
    callback: (objs: THREE.Object3D[]) => void
  ) {
    let insertObj: THREE.Object3D[] = [];
    lines.forEach((line) => {
      let startPoint = new THREE.Vector3(
        line.points[0],
        line.points[1],
        line.points[2]
      );
      let endPoint = new THREE.Vector3(
        line.points[3],
        line.points[4],
        line.points[5]
      );
      let direction1 = new THREE.Vector3()
        .subVectors(endPoint, startPoint)
        .normalize();
      direction1.z = 0;
      let raycaster1 = new THREE.Raycaster(startPoint, direction1);
      let direction2 = new THREE.Vector3()
        .subVectors(startPoint, endPoint)
        .normalize();
      direction2.z = 0;
      let raycaster2 = new THREE.Raycaster(endPoint, direction2);
      let intersects1 = raycaster1.intersectObjects(meshs);
      let intersects2 = raycaster2.intersectObjects(meshs);
      if (intersects1.length > 0 && intersects2.length > 0) {
        let intersectObj1 = intersects1.map((intersects) => intersects.object);
        let intersectObj2 = intersects2.map((intersects) => intersects.object);
        let commonObj = intersectObj1.filter((intersect) => {
          return intersectObj2.includes(intersect);
        });
        insertObj.push(...commonObj);
      }
    });
    insertObj = [...new Set(insertObj)].map(
      (item) => item.parent as THREE.Object3D
    );
    callback(insertObj);
  }

  // static LinesToModel(
  //   lines: DbLine[],
  //   lineMesh: THREE.LineSegments | THREE.Line
  // ) {
  //   let position: number[] = [];
  //   let index = 0;
  //   let indexs: number[] = [];
  //   lines.forEach((item) => {
  //     item.points.forEach((p) => {
  //       position.push(p);
  //     });
  //     item.indexes?.forEach((v) => {
  //       indexs.push(v + index);
  //     });
  //     index += item.points.length / 3;
  //   });
  //   let posistionArray = new Float32Array(position);
  //   let lineGeo = lineMesh.geometry as THREE.BufferGeometry;
  //   lineGeo.setAttribute(
  //     "position",
  //     new THREE.BufferAttribute(posistionArray, 3)
  //   );
  //   lineGeo.setIndex(indexs);
  //   lineGeo.attributes.position.needsUpdate = true;
  //   lineGeo.computeBoundingBox();
  //   lineGeo.computeBoundingSphere();
  // }

  // static MeshToModel(meshs: DbMesh[], modelMesh: THREE.Mesh) {
  //   let posistion: number[] = [];
  //   meshs.forEach((geo) => {
  //     geo.vertexs?.forEach((v) => {
  //       posistion.push(v);
  //     });
  //   });
  //   let posistionArray = new Float32Array(posistion);
  //   let meshGeo = modelMesh.geometry as THREE.BufferGeometry;
  //   meshGeo.setAttribute(
  //     "position",
  //     new THREE.BufferAttribute(posistionArray, 3)
  //   );
  //   meshGeo.attributes.position.needsUpdate = true;
  //   meshGeo.computeBoundingBox();
  //   meshGeo.computeBoundingSphere();
  // }
  // 判断点对构建的线是否在这个box 有关联(相交或者包含在内部)
  static RectFilterLineSegement(
    minpoint: THREE.Vector3,
    maxpoint: THREE.Vector3,
    pointpair: [THREE.Vector3, THREE.Vector3],
    tolerance: number = 0.01
  ): boolean {
    if (minpoint == null || maxpoint == null || pointpair == null) {
      return false;
    }
    function isLineSegementIntersection(
      x1: number,
      y1: number,
      x2: number,
      y2: number,
      x3: number,
      y3: number,
      x4: number,
      y4: number
    ) {
      let ua, ub, denom;
      denom = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);
      if (denom == 0) {
        return false; // 两条线段平行
      }
      var percent = 1 / denom;
      ua = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) * percent;
      ub = ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) * percent;
      if (ua < 0 || ua > 1 || ub < 0 || ub > 1) {
        return false; // 两条线段没有交点
      }
      return true;
    }
    //相等 (tolerance 允许的误差)
    function doubleEqual(n1: number, n2: number, tolerance: number): boolean {
      return Math.abs(n1 - n2) < tolerance;
    }

    //小于等于
    function doubleLEqual(n1: number, n2: number, tolerance: number): boolean {
      return n1 < n2 || doubleEqual(n1, n2, tolerance);
    }

    //大于等于
    function doubleGEqual(n1: number, n2: number, tolerance: number): boolean {
      return n1 > n2 || doubleEqual(n1, n2, tolerance);
    }

    //介于两者之间
    function doubleBetween(
      val: number,
      val1: number,
      val2: number,
      tol: number
    ) {
      if (val1 > val2) {
        var c = val1;
        val1 = val2;
        val2 = c;
      }

      return doubleGEqual(val, val1, tol) && doubleLEqual(val, val2, tol);
    }

    var x_min = Math.min(minpoint.x, maxpoint.x);
    var x_max = Math.max(minpoint.x, maxpoint.x);
    var y_min = Math.min(minpoint.y, maxpoint.y);
    var y_max = Math.max(minpoint.y, maxpoint.y);

    var obj_x_min = Math.min(pointpair[0].x, pointpair[1].x);
    var obj_x_max = Math.max(pointpair[0].x, pointpair[1].x);
    var obj_y_min = Math.min(pointpair[0].y, pointpair[1].y);
    var obj_y_max = Math.max(pointpair[0].y, pointpair[1].y);

    //if (!(CommonUtils.DLessEqual(obj_x_max, x_min, tolerance) || CommonUtils.DLessEqual(x_max, obj_x_min, tolerance) || CommonUtils.DLessEqual(obj_y_max, y_min, tolerance) || CommonUtils.DLessEqual(y_max, obj_y_min, tolerance)))
    //{
    //    return true;
    //}

    //boundingbox
    if (
      doubleLEqual(obj_x_max, x_min, tolerance) ||
      doubleLEqual(x_max, obj_x_min, tolerance) ||
      doubleLEqual(obj_y_max, y_min, tolerance) ||
      doubleLEqual(y_max, obj_y_min, tolerance)
    ) {
      return false;
    }

    if (
      (doubleBetween(pointpair[0].x, x_min, x_max, tolerance) &&
        doubleBetween(pointpair[0].y, y_min, y_max, tolerance)) ||
      (doubleBetween(pointpair[1].x, x_min, x_max, tolerance) &&
        doubleBetween(pointpair[1].y, y_min, y_max, tolerance)) ||
      (doubleBetween(
        (pointpair[1].x + pointpair[0].x) * 0.5,
        x_min,
        x_max,
        tolerance
      ) &&
        doubleBetween(
          (pointpair[1].y + pointpair[0].y) * 0.5,
          y_min,
          y_max,
          tolerance
        ))
    ) {
      return true;
    } else if (
      isLineSegementIntersection(
        x_min,
        y_min,
        x_min,
        y_max,
        pointpair[0].x,
        pointpair[0].y,
        pointpair[1].x,
        pointpair[1].y
      ) ||
      isLineSegementIntersection(
        x_min,
        y_max,
        x_max,
        y_max,
        pointpair[0].x,
        pointpair[0].y,
        pointpair[1].x,
        pointpair[1].y
      ) ||
      isLineSegementIntersection(
        x_max,
        y_min,
        x_max,
        y_max,
        pointpair[0].x,
        pointpair[0].y,
        pointpair[1].x,
        pointpair[1].y
      ) ||
      isLineSegementIntersection(
        x_min,
        y_min,
        x_max,
        y_min,
        pointpair[0].x,
        pointpair[0].y,
        pointpair[1].x,
        pointpair[1].y
      )
    ) {
      return true;
    }

    return false;
  }
}
